// Default configuration that will be used if no specific municipal config is found
const DEFAULT_CONFIG = {
    hidePayTab: true,
    hideTaxVouchersTab: true,
    hidePermitsTab: false,
    hideComplaintsTab: false,
    hideDashboardTab: false,
};

// Municipal-specific configurations
const MUNI_CONFIGS = {
    'simi-valley-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'key-biscayne-fl': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": false
    },
    'columbia-sc': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'cathedral-city-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'desert-hot-springs-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'mineral-wells-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'townsend-tn': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": false,
        "hideComplaintsTab": false,
        "hideDashboardTab": false
    },
    'mercer-wi': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": false,
        "hideComplaintsTab": false,
        "hideDashboardTab": false
    },
    'san-marcos-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'kane-county-il': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": false,
        "hideComplaintsTab": false,
        "hideDashboardTab": false
    },
    'aledo-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'hudson-ny': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'nacogdoches-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'redwood-city-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'mcfarland-wi': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'arroyo-grande-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'la-porte-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'euless-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'bastrop-county-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'amarillo-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'lander-wy': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'provo-ut': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'west-tawakoni-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'west-sacramento-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'canyon-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'duncanville-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'wimberley-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'ukiah-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'tyler-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'south-san-francisco-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'santa-clara-county-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'san-ramon-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'san-mateo-county-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'san-mateo-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'roseville-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'rocklin-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'riverside-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'rancho-cordova-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'port-hueneme-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'pomona-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'pacifica-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'novato-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'mulberry-ga': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'monterey-park-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'menlo-park-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'marina-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'manteca-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'lodi-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'lakeport-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'haltom-city-tx': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'half-moon-bay-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'glendora-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'folsom-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'fayette-county-pa': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'escondido-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'el-cajon-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'daly-city-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'clovis-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'chico-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'carpinteria-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'capitola-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'benicia-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'auburn-ca': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'gunnison-co': {
        "hidePayTab": true,
        "hideTaxVouchersTab": false,
        "hidePermitsTab": false,
        "hideComplaintsTab": false,
        "hideDashboardTab": false
    },
    'collegedale-tn': {
        "hidePayTab": true,
        "hideTaxVouchersTab": true,
        "hidePermitsTab": true,
        "hideComplaintsTab": true,
        "hideDashboardTab": true
    },
    'rich-county-ut': {
        hidePayTab: true,
        hideTaxVouchersTab: true,
        hidePermitsTab: false,
        hideComplaintsTab: false,
        hideDashboardTab: false
    },
    'garden-city-ut': {
        hidePayTab: true,
        hideTaxVouchersTab: true,
        hidePermitsTab: false,
        hideComplaintsTab: false,
        hideDashboardTab: false
    },
    'summit-county-ut': {
        hidePayTab: true,
        hideTaxVouchersTab: true,
        hidePermitsTab: true,
        hideComplaintsTab: false,
        hideDashboardTab: false
    }
};

/**
 * Returns the configuration for a specific municipality
 * @param {string} municipality_id - The ID of the municipality
 * @returns {Object} Configuration object containing feature flags
 */
export const getConfig = (municipality_id) => {
    // If there's a specific config for this municipality, return it
    if (MUNI_CONFIGS.hasOwnProperty(municipality_id)) {
        return MUNI_CONFIGS[municipality_id];
    }

    // Otherwise return the default config
    return DEFAULT_CONFIG;
};
